import { type Trip } from '@/api/accommodation/types'
import { Button } from '@/components/ui/button'
import { ImagePlaceholder } from '@/components/ui/ImagePlaceholder'
import { Typography } from '@/components/ui/typography'

function formatDistance(meters: number): string {
  if (meters < 1000) {
    return `${Math.round(meters)} m`
  }
  const km = meters / 1000
  const rounded = km < 10 ? km.toFixed(1) : Math.round(km).toString()
  return `${rounded.replace('.', ',')} km`
}

export function TripCard({ trip }: { trip: Trip }) {
  return (
    <div className="flex flex-col gap-3 overflow-hidden rounded-2xl bg-slate-50 p-4">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-3">
        <div className="flex flex-col gap-0.5 md:order-2 md:flex-1">
          <span className="text-xs text-slate-500">{formatDistance(trip.distance)}</span>
          <Typography variant="h5" as="p" className="leading-tight font-medium text-balance text-slate-900">
            {trip.title}
          </Typography>
        </div>
        <div className="order-2 aspect-7/5 w-full shrink-0 md:order-1 md:h-28 md:w-32">
          {trip.imageUrl ? (
            <img src={trip.imageUrl} alt={trip.title} className="h-full w-full rounded-xl object-cover" />
          ) : (
            <ImagePlaceholder className="h-full w-full rounded-xl" />
          )}
        </div>
      </div>
      <p className="text-sm text-slate-700">{trip.description}</p>
      {trip.url && (
        <Button asChild variant="secondary" size="sm" className="self-start">
          <a href={trip.url} target="_blank" rel="nofollow noreferrer">
            Zobrazit více
          </a>
        </Button>
      )}
    </div>
  )
}
